export default __webpack_public_path__ + "static/media/logoguasasapo.03d4d696.png";